import { render, staticRenderFns } from "./WhoAreWePage.vue?vue&type=template&id=3bce0864"
import script from "./WhoAreWePage.vue?vue&type=script&lang=js"
export * from "./WhoAreWePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports